
import {startWith, map, debounceTime} from 'rxjs/operators';
import {Component, Output, EventEmitter} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CostStudy} from "../../../services/CostStudy";

@Component({
  selector: 'cs-contracts-search-box',
  templateUrl: './search.html',
})
export class CSContactsSearchBoxCmp {
  @Output('contractChange') contractChange = new EventEmitter();
  public searchInput:UntypedFormControl;
  public searchTerm:string;
  public results = [];
  public listVisible = false;
  public kIndex = 0;
  public loaded = false;
  public searchGroup = new UntypedFormGroup({
    searchInput: new UntypedFormControl()
  });

  constructor(public csSrv:CostStudy) {
    this.searchInput = <UntypedFormControl>this.searchGroup.controls['searchInput'];
    this.searchInput.valueChanges.pipe(debounceTime(150),map((val) => {
      return val.toLowerCase();
    }),startWith('')).subscribe((val)=> {
      if (!this.searchTerm && !val) {
        return false;
      }
      this.searchTerm = val;
      this.showSearchResults(this.searchTerm);
    }, ()=> {});
    this.loaded = true;
  }

  preventBubbling($event?) {
    if ($event) {
      if ($event.stopPropagation) {
        $event.stopPropagation();
      }
      if ($event.preventDefault) {
        $event.preventDefault();
      }
    }
  }

  showSearchResults(searchTerm) {
    this.kIndex = 0;
    this.loaded = false;
    this.results = [];
    this.csSrv.search(searchTerm, 10).subscribe((contracts)=> {
      this.results = contracts;
      this.listVisible = (this.results.length > 0);
      this.loaded = true;
    }, ()=> {
      this.loaded = true;
    });
  }

  selectItem(item, $event?) {
    this.removeList();
    this.results = [];
    this.searchTerm = '';
    this.searchInput.setValue('');
    setTimeout(()=> {
      this.contractChange.emit(item);
    }, 0);
    this.preventBubbling($event);
    return false;
  }

  removeList() {
    this.listVisible = false;
  };

  blurSearch($event?) {
    setTimeout(()=> {
      if (this.listVisible) {
        this.removeList();
      }
    }, 250);
    this.preventBubbling($event);
    return false;
  }

  searchKey($event) {
    if (!this.results || !this.results.length) {
      return;
    }
    if (($event.keyCode === 38 || $event.code === 'ArrowUp')) {
      if (this.kIndex > 0) {
        this.kIndex--;
      } else {
        this.kIndex = this.results.length;
      }
    }
    if (($event.keyCode === 40 || $event.code === 'ArrowDown')) {
      if (this.kIndex < this.results.length) {
        this.kIndex++;
      } else {
        this.kIndex = 0;
      }
    }
    if ($event.keyCode === 13 || $event.code === 'Enter') {
      if (this.kIndex === 0) {

      } else {
        let c = this.results[(this.kIndex - 1)];
        if (c) {
          this.selectItem(c);
        } else {

        }
      }
    }
  }
}
